export enum WindowsName {
    Main = "Main",
    Overlay = "Overlay",
}

// TODO: 暂定主要窗口大小为1200x800
export const PageSize = {
    Login: {
        width: 1288,
        height: 760,
    },
    Main: {
        width: 1288,
        height: 760,
    },
} as const;

export type WindowStatus = "minimize" | "maximize" | "close";

export const Portal = "portal;";

export enum RelationShip {
    Lovers = "lovers",
    BosomFriend = "bosom_friend",
    Buddy = "buddy",
}

export enum SideMenuTypes {
    USER = "users",
    CHANNEL = "channels",
    SETTING = "settings",
}

export enum VideoWindowLayoutTypes {
    Equal = "equal",
    Top = "top",
    Bottom = "bottom",
}
